import { useState } from 'react';

import { Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Button from 'common-ui/button';
import { AsyncSelect } from 'common-ui/select';
import { getTicketLinkOptions } from 'features/projectManagement/ProjectManagementActions';

import { Row } from '../addNewLead.styles';

const Step5 = ({
  control,
  errors,
  handleBack,
  handleSkip,
  handleSubmit,
  createLeadB2BLoading,
  createLeadB2CLoading,
}) => {
  const dispatch = useDispatch();
  const [ticketOptions, setTicketOptions] = useState([]);
  const [ticketOffset, setTicketOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const loadTickets = async (inputValue, isLoadMore = false, offset = 0) => {
    try {
      const response = await dispatch(
        getTicketLinkOptions({ search: inputValue, limit: 10, offset })
      ).unwrap();
      const options = (response.tickets || []).map((elm) => ({
        value: elm.uuid,
        label: `(${elm.taskId}) ${elm.name}`,
      }));
      if (isLoadMore && offset > 0) {
        setTicketOptions((prev) => [...prev, ...options]);
      } else {
        setTicketOptions(options);
      }
      setHasMore(response.count > offset + 10);
      setTicketOffset(offset + 10);
      return options;
    } catch {
      return [];
    }
  };

  const handleScrollToBottom = () => {
    if (hasMore) loadTickets('', true, ticketOffset);
  };

  return (
    <>
      <Controller
        name="ticketUuid"
        control={control}
        render={({ field: { onChange, value } }) => (
          <AsyncSelect
            value={value}
            onChange={onChange}
            label="Attach Ticket"
            placeholder="Search for a ticket"
            loadOptions={loadTickets}
            onMenuOpen={() => loadTickets('', false, 0)}
            onMenuScrollToBottom={handleScrollToBottom}
            defaultOptions={ticketOptions}
            isClearable
            cacheOptions
            $error={errors.ticketUuid?.message}
            getOptionValue={(option) => option.value}
          />
        )}
      />
      <Row style={{ marginTop: 24 }}>
        <Button outlined onClick={handleBack}>
          Back
        </Button>
        <Button outlined type="button" onClick={handleSkip}>
          Skip
        </Button>
        <Button
          secondary
          type="button"
          loading={createLeadB2BLoading || createLeadB2CLoading}
          onClick={handleSubmit}
        >
          Create Lead
        </Button>
      </Row>
    </>
  );
};

export default Step5;
